import http from "./http";
import config from "../common/config";
import downloadPdf from "../utils/downloadpdf";
import { data } from "jquery";
/*
 ** 获取合同编号下拉列表 gaa 20200806
 */
var baseUrl = "/contract-web";

// 更新审签表
const updateSubContractSignService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/sub/contract/updateSubContractSign", param, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


// 保存更新合同模板信息
const createOrUpdateSubContractPrint = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/sub/contract/createOrUpdateSubContractPrint", param, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//保存更新工程量清单
const createOrUpdateSubContractProjectDetailsPrint= param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/sub/contract/createOrUpdateSubContractProjectDetailsPrint", param, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getContractCodeByUserCodeService = category => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/common/dropDownList", category, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 获取数据字典下拉列表 gaa 20200923
 */
const getBasicDataListService = category => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/common/sysDictDetail", category, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//总包合同列表
const getAllContractList = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/general/contract/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询一条总包合同  20200817
const getContractDetailService = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/general/contract", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除总包合同列表一条数据 gaa 20200806
 */
const deleteOneAllContractSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/general/contract", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 撤回项目列表一条项目立项单数据 gaa 20200806
 */
const CallBackOneContractSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/general/contract/recall", data, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
//导出总包合同列表
const exportAllContractList = param => {
    let query = "?exportIds=";
    for (let index = 0; index < param.exportIds.length; index++) {
        const element = param.exportIds[index];
        if (index == 0) {
            query += element;
        } else {
            query += "&exportIds=" + element;
        }
    }
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/general/contract/export" + query, {})
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//导出分项合同
const exportServicesContractList = param => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/sub/contract/export", { exportIds: param }, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//导出项目立项单列表
const exportAllProjectList = param => {
    let query = "?exportIds=";
    for (let index = 0; index < param.exportIds.length; index++) {
        const element = param.exportIds[index];
        if (index == 0) {
            query += element;
        } else {
            query += "&exportIds=" + element;
        }
    }
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/export" + query, {})
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//获取临时下载地址
const getTempUrlService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/oss/getTempUrl", param, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 导出Excel表格请求
 ** 参数： url：   导出excel表格所请求的url
 **       param： 导出接口对应的请求参数
 ** 以缴费房间对应请求参数为例
 **     url   : '/xwj-property-payment/paymentRoomEnquiry/getRoomExcel'
 **     param : { data: JSON.stringify({"USER_ID": this.userCode, "PAGE_NAME":"缴费房间信息.zip"})}
 */
const exportExcelService2 = (url, param, needTrim = true) => {
    let baseUrl = config.baseUrl + "/contract-web";
    return new Promise((resolve, reject) => {
        //let exportUrl = `${baseUrl}${url}?`;
        let exportUrl = url;
        // for (let key in param) {
        //     if (param[key]) {
        //         exportUrl += `${/\?$/.test(exportUrl) ? '' : '&'}${key}=${encodeURI(param[key])}`;
        //         console.log(exportUrl)
        //     }
        // }
        try {
            const downloadUrl = needTrim ? exportUrl.replace(/\s*/g, "") : exportUrl
            if (downloadUrl.indexOf("pdf")!=-1) {
                downloadPdf(downloadUrl)
            } else {
                var elemIF = document.createElement("iframe");
                elemIF.src = downloadUrl
                elemIF.style.display = "none";
                document.body.appendChild(elemIF);
                let self = this;
                elemIF.onload = function () {
                    reject();
                };
            }
        } catch (e) {
            console.error(e);
        }
    });
};

const overViewService = (url, param, needTrim = true) => {
    return new Promise((resolve, reject) => {
        let exportUrl = url;
        try {
            var elemIF = document.createElement("iframe");
            elemIF.src = needTrim ? exportUrl.replace(/\s*/g, "") : exportUrl;
            // elemIF.style.display = "none";
            document.body.appendChild(elemIF);
            let self = this;
            elemIF.onload = function () {
                reject();
            };
            // window.open(exportUrl, "_blank");
        } catch (e) {
            console.error(e);
        }
    });
};

//获取上传文件url
const getFileUploadUrl = () => {
    return config.uploadUrl + "/oss/upload/contract/items";
};

//批量上传文件
const uploadFilesService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/oss/upload/contract/items", param, false, true, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除文件附件
const deleteFileService = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/oss/object/delete?filePath=" + data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//审批通过后，上传附件
const insertItemsAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/general/contract/insertItemsAfterAudit", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除审批通过后上传的附件
const deleteItemsAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/general/contract/deleteItemsAfterAudit", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//审批通过后，上传项目附件
const insertProjectAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/project/insertItemsAfterAudit", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除项目审批通过后上传的附件
const deleteProjectAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/project/deleteItemsAfterAudit", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//审批通过后，上传分包附件
const insertSubcontractAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/sub/contract/insertItemsAfterAudit", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除分项合同审批通过后上传的附件
const deleteSubcontractAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/sub/contract/deleteItemsAfterAudit", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 分项合同上传合同扫描件接口
const uploadContractFilesService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/oss/upload/contract/multiScan",
                param,
                false,
                true,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//确认上传合同扫描件接口
const confirmuploadFilesService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/sub/contract/replaceScans",
                param,
                false
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
//下载工程里清单模板
const exportProjectListExcel = param => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/common/template/projectDetails", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//下载总包合同模板
const exportContractExcel = param => {
    return new Promise((resolve, reject) => {
        exportExcelService2("/hisense/download/sys/template/roomManage.xlsx", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//获取导入工程量清单接口(老接口地址：/common/import/projectDetails)
const getUploadProjectUrl = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/general/contract/import/projectDetails",
                param,
                false,
                false,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
    // return config.baseUrl +baseUrl+ "/common/import/projectDetails"
};

//获取导入物资采购接口
const getUploadmaterialUrl = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/common/import/materialDetails",
                param,
                false,
                false,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
    // return config.baseUrl +baseUrl+ "/common/import/projectDetails"
};

//查询当前审批流接口
const getApproveListService = param => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/general/contract/queryApproveProcess", param, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//同意审批总包合同接口 gaa 20200806
const confirmContractApproveServices = param => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/general/contract/submitApproveProcess", param, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


// 保存总包合同基础信息
const saveContractInfoServices = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/general/contract", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新总包合同基础信息
const updateContractInfoServices = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/general/contract", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


/* 以下为项目管理相关接口
 ** 获取项目管理列表数据 gaa 20200810
 */

const getProjectListServices = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 保存一条项目立项单基础信息
const saveProjectInfoServices = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/project", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条项目立项单基础信息
const updateProjectInfoServices = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/project", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询当前审批流接口
const getProjectApproveListService = param => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/queryApproveProcess", param, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//审批项目立项单接口 gaa 20200810
const confirmProjectApproveServices = param => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/project/submitApproveProcess", param, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除项目列表一条项目立项单数据 gaa 20200806
 */
const deleteOneProjectSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/project", data, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 手动生成事前成本
 */
 const autoGenerateProjectDetailsData = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/project/autoGenerateProjectDetailsData", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 撤回项目列表一条项目立项单数据 gaa 20200806
 */
const CallBackOneProjectSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/project/recall", data, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 获取一条项目立项单数据 gaa 20200810
 */
const getProjectDetailService = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//获取工程量清单所有子目数据
const getProjectDetailsList = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/dict/projectDetails", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//获取物资采购所有子目数据
const getallSubGoodListService = (param, loading = false) => {
    
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/dict/materialDetails", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//财务分类总览
const getFinanceOverAllService = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/financeType/overall", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//财务分类明细
const getFinanceDetailService = (param, loading = false) => {
    let query =
        "?projectId=" + param.projectId + "&typeKey=" + param.typeKey.toString() + "&pTypeKey=" + param.pTypeKey.toString();
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/financeType/detail" + query)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//工程分类总览
const getProjectOverAllService = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/projectType/overall", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//工程分类明细
const getProjectTypeDetailService = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(
                baseUrl + "/project/projectType/chapterDetail",
                param,
                false,
                loading
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//工程分类子目明细
const getProjectsubDetailService = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(
                baseUrl + "/project/projectType/subCategoryDetail",
                param,
                false,
                loading
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


/* 分项合同相关接口 gaa 20200812
 ** 获取劳务合同工程量清单数据
 */
//劳务合同列表
const getSubServicesContractList = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/sub/contract/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//
//查询一条劳务合同  20200824
const getServiceContractDetailService = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/sub/contract", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 保存一条分项合同基础信息
const saveServiceContractServices = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/sub/contract", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条分项合同基础信息
const updateServiceContractInfoServices = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/sub/contract", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除劳务合同列表一条数据 gaa 20200824
 */
const deleteOneSubServiceContractSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/sub/contract", data, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//保存项目经理接口
const saveProjectUser = data => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/general/contract/assignCharge", data, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 分项合同-获取分项合同默认细目
const getDefaultDetailsServices = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/middle/subContract/getDefaultDetails", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//基础数据接口
//工程量清单（总包）
//获取工程量清单字典
const getprojectDetailsListService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/dict/projectDetails", param, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新工程量清单
const updateProjectDetailsDictService = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/updateProjectDetailsDict", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除工程量清单接口 gaa 20211228
 */
const deleteProjectDetailsDictSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/deleteProjectDetailsDict", data, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
//获取物资采购清单字典
const getmaterialDetailsListService = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/dict/materialDetails", data, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新采购清单
const updateMaterialDetailsDictService = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/updateMaterialDetailsDict", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除采购清单接口 gaa 20211228
 */
const deleteMaterialDetailsDictSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/deleteMaterialDetailsDict", data, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//获取内部定额表字典
const getOtherDetailsListService = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/dict/quotaDetails", data, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新内部定额表
const updateOtherDetailsDictService = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/updateQuotaDetailsDict", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除内部定额表接口 gaa 20211228
 */
const deleteOtherDetailsDictSevice = data => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/common/deleteQuotaDetailsDict", data, true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 导入工程量清单接口
const uploadProjectListService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/common/import/projectDetailsDict",
                param,
                false,
                true,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 确认导入工程量清单字典接口
const confirmuploadProjectListService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/common/doImportProjectDetailsDict",
                param,
                false,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 导入物资采购接口
const uploadmaterialDetailsDictService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/common/import/materialDetailsDict",
                param,
                false,
                true,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 确认导入物资采购字典接口
const confirmexportmaterialDetailsDictList = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/common/doImportMaterialDetailsDict",
                param,
                false,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//导出工程量清单字典
const exportprojectDetailsDictList = () => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + "/common/export/projectDetailsDict", {})
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//导出物资采购字典
const exportmaterialDetailsDictList = () => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + "/common/export/materialDetailsDict", {})
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//内部定额表

// 导入内部定额表接口
const uploadOtherDetailsDictService = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/common/import/quotaDetails",
                param,
                false,
                true,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 确认导入内部定额表字典接口
const confirmexportOtherDetailsDictList = param => {
    return new Promise((resolve, reject) => {
        http
            .post(
                baseUrl + "/common/doImportQuotaDetailsDict",
                param,
                false,
                true
            )
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//导出内部定额表字典
const exportOtherDetailsDictList = () => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + "/common/export/quotaDetailsDict", {})
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//下载导入模板
const getTemplate = param => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/oss/template", { "category": param })
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//根据查询条件导出总包合同列表
const exportContractList = param => {

    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/general/contract/export/all", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
//根据查询条件导出项目列表
const exportProjectList = param => {

    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/export/all", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
//根据查询条件导出总包合同列表
const exportsubContractList = param => {

    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/sub/contract/export/all", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
//项目附件删除记录
const delFileRecord = param => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/project/queryProjectItemsOperateRecords", param, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
export {
    updateSubContractSignService, //更新审签表
    createOrUpdateSubContractPrint,  //保存更新合同模板信息
    createOrUpdateSubContractProjectDetailsPrint, //更新工程量清单
    getContractCodeByUserCodeService, //获取合同编号下拉框数据接口
    saveContractInfoServices, //保存总包合同基础信息
    updateContractInfoServices, //更新一条总包合同基础信息
    confirmContractApproveServices, //同意审批总包合同接口
    getAllContractList, //获取总包合同列表
    exportAllContractList, //导出总包合同列表
    // getUploadContractUrl,    //导入总包合同接
    exportContractExcel, //下载总包合同模板
    getUploadProjectUrl, //导入工程量清单接口
    exportProjectListExcel, //下载工程量清单模板
    deleteOneAllContractSevice, //删除一条总包合同数据
    CallBackOneContractSevice, //撤回一条总包合同
    getContractDetailService, //获取一条总包合同数据
    // getProjectGMListService,     //获取审批列表项目经理下拉框列表数据
    getApproveListService, //查询当前审批流接口
    uploadContractFilesService, //分项合同上传合同扫描件接口
    exportExcelService2,
    getBasicDataListService, //获取合同相关数据字典下拉列表
    getTempUrlService, //获取临时下载地址附件接口
    saveProjectUser, //审批保存项目经理
    insertItemsAfterAudit,
    deleteItemsAfterAudit,

    //项目管理相关接口
    getProjectDetailService, //获取一条项目立项单数据信息
    saveProjectInfoServices, //新增一条项目立项单信息
    updateProjectInfoServices, //更新一条项目立项单信息
    getProjectListServices, //获取项目管理列表数据
    getProjectApproveListService, //查询项目审批流
    confirmProjectApproveServices, //审批项目立项单接口
    autoGenerateProjectDetailsData,
    deleteOneProjectSevice, //删除一条项目立项单数据
    CallBackOneProjectSevice, //撤回一条项目立项单数据
    insertProjectAfterAudit,
    deleteProjectAfterAudit,
    insertSubcontractAfterAudit,
    deleteSubcontractAfterAudit,
    //工程量清单界面相关接口
    getFinanceOverAllService, //获取财务分类总览数据
    getFinanceDetailService, //获取财务分类明细数据
    getProjectOverAllService, //获取工程分类总览数据
    getProjectTypeDetailService, //获取工程分类章节数据
    getProjectsubDetailService, //获取工程分类章节子目数据
    getProjectDetailsList, //获取全部工程量清单子目列表
    exportAllProjectList, //导出项目立项单接口

    getallSubGoodListService,   //获取物资采购清单子目列表
    //分项合同相关接口
    getSubServicesContractList, //分项合同列表
    saveServiceContractServices, //新增分项合同接口
    updateServiceContractInfoServices, //更新分项合同接口
    getServiceContractDetailService, //查询一条分项合同
    deleteOneSubServiceContractSevice, //删除一条劳务合同接口
    exportServicesContractList, //导出分项合同接口
    uploadFilesService, //上传文件接口
    getUploadmaterialUrl,  //导入物资采购清单接口
    confirmuploadFilesService,   //确认上传合同扫描件接口
    deleteFileService,   //删除文件接口
    getDefaultDetailsServices,
    //基础数据接口
    uploadProjectListService,   //导入工程量清单字典接口
    confirmuploadProjectListService,   //确认导入工程量清单字典接口
    uploadmaterialDetailsDictService, //导入物资采购字典接口
    confirmexportmaterialDetailsDictList,  //确认导入物资采购字典接口
    exportprojectDetailsDictList,    //导出工程量清单字典
    exportmaterialDetailsDictList,  //导出物资采购字典
    exportOtherDetailsDictList,   //内部定额表
    uploadOtherDetailsDictService,
    confirmexportOtherDetailsDictList,
    getTemplate,    //下载导入模板
    getprojectDetailsListService,    //获取工程量清单字典
    deleteProjectDetailsDictSevice,
    updateProjectDetailsDictService,   //更新工程量清单数据
    getmaterialDetailsListService,   //获取物资采购清单
    updateMaterialDetailsDictService,  // 更新物资采购清单
    deleteMaterialDetailsDictSevice,  //删除物资采购清单

    updateOtherDetailsDictService,  //更新内部定额表
    deleteOtherDetailsDictSevice,   //删除内部定额表

    getOtherDetailsListService, //获取内部定额表
    exportContractList,  //根据查询条件导出总包合同
    exportProjectList,   //根据查询条件导出项目
    exportsubContractList,  ///根据查询条件导出分项合同
    overViewService,  //预览文件接口
    getFileUploadUrl, //上传附件文件列表
    delFileRecord,  //获取项目附件删除记录

};
